module.exports = __webpack_public_path__ + "fonts/a.5ebde62d.ttf";